// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_RCA","cls2":"CiterightLanding-cls2_Rwe CiterightLanding-cls1_RCA"};